import styled from "styled-components";

export const TabContainer = styled.div`
  display: flex;
  align-items: end;
  padding: 0 2rem;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.border1}`};
  height: "10%";
`;